// extracted by mini-css-extract-plugin
module.exports = {"bookForm":"book-form_bookForm__3Y8b8"};